class BlockOurJob {
  private cards: NodeListOf<HTMLElement> =
    document.querySelectorAll('.job-card');

  constructor() {
    if (!this.cards) return;
    this._init();
  }

  private _init(): void {
    const container = document.querySelector('.our-jobs');
    if (!container) return;

    this.cards = container.querySelectorAll('.job-card');
    this._bindEvents();
  }

  private _bindEvents(): void {
    this.cards.forEach((card) => {
      const toggleBtn = card.querySelector('.card-toggle') as HTMLElement;
      const closeBtn = card.querySelector('.close-btn');
      const detail = card.querySelector('.card-detail') as HTMLElement;

      toggleBtn?.addEventListener('click', () => {
        this._closeAll();
        if (detail) {
          detail.classList.add('is-visible');
        }
        if (toggleBtn) {
          toggleBtn.classList.add('hidden-fade');
        }
      });

      closeBtn?.addEventListener('click', () => {
        detail.classList.remove('is-visible');
        toggleBtn.classList.remove('hidden-fade');
      });
    });
  }

  private _closeAll(): void {
    this.cards.forEach((card) => {
      const detail = card.querySelector('.card-detail') as HTMLElement;
      const toggleBtn = card.querySelector('.card-toggle') as HTMLElement;

      detail?.classList.remove('is-visible');
      toggleBtn.classList.remove('hidden-fade');
    });
  }
}

export const blockOurJob = new BlockOurJob();
